module.exports = __webpack_public_path__ + "img/proList2_27_05.db355669.jpg";